<sb-dashboard-widget
  [isLoading]="isLoading()"
  [isEmpty]="newsItems().length === 0"
  [title]="'My news messages' | translate"
  [emptySettings]="{
    description: 'No news yet — messages you post will appear here.' | translate,
    icon: 'news-2-cute-re',
    buttonLabel: 'Add message' | translate,
  }"
  (emptyAction)="onAddNewsMessageClick()"
>
  <!-- TODO check e2e, this probably isn't targeting the input itself now -->
  <sb-dashboard-widget-select
    [options]="periodOptions"
    [model]="widgetPeriod()"
    (modelChange)="onPeriodChange($event)"
    [label]="'Last' | translate"
  />
  <table class="table-widget table-uniform-rows">
    <thead>
      <tr>
        <th class="row-30">{{ 'Name' | translate }}</th>
        <th class="row-20">{{ 'Date' | translate }}</th>
        <th class="row-50">{{ 'Title' | translate }}</th>
      </tr>
    </thead>
    <tbody>
      @for (newsItem of newsItems(); track newsItem.id) {
        <tr [routerLink]="['/news', { newsId: newsItem.id }]" class="cursor-pointer" role="link">
          <td>{{ newsItem.Author?.name }}</td>
          <td>{{ newsItem.created | localeDate: 'medium' }}</td>
          <td>{{ newsItem.title }}</td>
        </tr>
      }
    </tbody>
  </table>
</sb-dashboard-widget>
